import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import routes from 'app/routes';
import ExternalLink from 'components/Widgets/ExternalLink';

export default function Actions({ program }) {
  const {
    status,
    link,
    possible_to_change_coach: possibleToChangeCoach,
  } = program.attributes;
  const cpaProgram = program.attributes.program_type === 'cpa_only_program';

  return (
    <div className="d-flex justify-content-end pt-3">
      {cpaProgram ? (
        <>
          {status === 'completed' ? (
            <>
              {link && (
                <ExternalLink
                  href={link}
                >
                  View Report
                </ExternalLink>
              )}
            </>
          ) : (
            <a
              href={`${routes.members.onboarding.index}?program_id=${program.id}`}
              className="btn btn-primary"
            >
              Start
            </a>
          )}
        </>
      ) : (
        <>
          {((status !== 'assigned') && (status !== 'completed' || program.attributes.coach)) && (
            <Link
              to={routes.members.programs.show(program.id)}
              className={`btn btn-primary ${possibleToChangeCoach ? 'disabled' : ''}`}
            >
              {status === 'saved_for_later' ? 'View & Start' : 'View'}
            </Link>
          )}
          {status === 'assigned' && (
            <a
              href={`${routes.members.onboarding.index}?program_id=${program.id}`}
              className="btn btn-primary"
            >
              Start
            </a>
          )}
        </>
      )}
    </div>
  );
}

Actions.propTypes = {
  program: PropTypes.object.isRequired,
};
